/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchSupportFlow} from '../api'

export const useMutationSearchSupportFlow = createReactQueryMutationHook('searchSupportFlow', searchSupportFlow)
